import React, { useState } from 'react';
import planQueueStyles from '../PlanQueue/PlanQueue.styles';
import styles from './AgentActionGroups.styles';
import type { AgentActionGroup } from 'configuration-schemas/viewdefns/viewdefn';
import { AgentActionGroup as AgentActionGroupComponent } from './AgentActions/AgentActionGroup';

interface AgentActionGroupProps {
  search?: string;
  onSearchChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  actionGroups?: AgentActionGroup[];
  scope: {
    productMember: string | null;
    locationMember: string | null;
  };
}

export const AgentActionGroups = ({ search = '', onSearchChange, actionGroups = [], scope }: AgentActionGroupProps) => {
  const [localSearch, setLocalSearch] = useState(search);

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLocalSearch(event.target.value);
    if (onSearchChange) {
      onSearchChange(event);
    }
  };

  // Filter action groups based on search
  const filteredActionGroups = actionGroups.map((group) => {
    if (!localSearch) {
      return group;
    }

    const searchLower = localSearch.toLowerCase();
    const matchesGroup = group.text.toLowerCase().includes(searchLower);

    if (matchesGroup) {
      return group;
    }

    const filteredActions = group.actions.filter((action) =>
      action.text.toLowerCase().includes(searchLower) ||
      action.description.toLowerCase().includes(searchLower)
    );

    return {
      ...group,
      actions: filteredActions,
    };
  }).filter((group) => {
    const searchLower = localSearch.toLowerCase();
    const matchesGroup = group.text.toLowerCase().includes(searchLower);
    return matchesGroup || group.actions.length > 0;
  });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div className={planQueueStyles.searchContainer}>
        <input
          type="text"
          placeholder="Search Action..."
          value={localSearch}
          onChange={handleSearchChange}
        />
      </div>
      <section className={planQueueStyles.itemsContainer} style={{ flex: 1, minHeight: 1, overflowY: 'auto' }}>
        <div className={styles.accordionContainer}>
          {filteredActionGroups.map((group, groupIndex) => (
            <AgentActionGroupComponent
              key={`${group.text}-${groupIndex}`}
              group={group}
              groupIndex={groupIndex}
              scope={scope}
            />
          ))}
          {filteredActionGroups.length === 0 && (
            <div className={styles.noResults}>
              No actions found matching &quot;{localSearch}&quot;
            </div>
          )}
        </div>
      </section>
    </div>
  );
};
